export default "__VITE_ASSET__D42OoXmT__"